import React from 'react';
import palette from '../../palette';
import {DateInput} from '@ab/components';

const dateButtonStyle = {
    paddingLeft: palette.gutter * 2,
    paddingRight: palette.gutter * 2,
};

const CustomDateInput = props => {
    return (
        <DateInput
            cancelButton={{
                flatPrimary: false,
                style: dateButtonStyle,
            }}
            submitButton={{
                primary: true,
                style: dateButtonStyle,
            }}
            {...props}
        />
    );
};

export default CustomDateInput;
